export default __webpack_public_path__ + "static/media/captur-gallery-8.6440bc73.jpg";